<div class="container">
  <h1 mat-card-title>{{ title }}</h1>
  <mat-dialog-content>
    <table-responsive
      [length]="length"
      (changePage)="changePage($event)"
      (filter)="filter($event)"
      [displayedColumns]="displayedColumns"
      [dataSource]="dataSource"
      [configColumns]="configColumns"
      [hasAdd]="false"
      [type]="dataSelect?.type!"
      (onSelect)="onSelect($event)"
    ></table-responsive>
  </mat-dialog-content>
  <div
    class="dynamic-field form-button"
    align="end"
    style="margin-top: 20px"
    *ngIf="dataSelect?.select"
  >
    <button mat-button (click)="onCancel()">CANCELAR</button>
  </div>
</div>
